<template>
    <div>
        <div class="modal-close-btn-point">
            <div class="modal-close-btn-container" v-on:click="$emit('close')">
                <SVGModalClose/>
            </div>
        </div>
        <div class="ap-modal-title-big">
            {{title}}
        </div>
        <div class="modal-borderline no-margin-top"></div>
        <div class="ap-modal-element">{{text}}</div>
        <div class="confirmation-btn-grid">
            <div class="ap-modal-button profile-btn hide-underline btn-fixed-size" @click="accept">
                Подтвердить
            </div>
            <div class="modal-button profile-btn hide-underline btn-fixed-size" v-on:click="$emit('close')">
                Отмена
            </div>
        </div>
<!--        {{methodParam}}-->
    </div>
</template>

<script>
    import SVGModalClose from "../SVG/SVGModalClose";
    export default {
        name: "ModalConfirmation",
        components: {
            SVGModalClose
        },
        props: {
            title: {
              type: String,
              default(){
                  return '';
              }
            },
            text: {
                type: String
            },
            alright: {
                type: Function
            }
        },
        methods: {
            accept() {
                this.alright();
                this.$emit('close');
            }
        }
    }
</script>

<style scoped>
    .btn-fixed-size {
        width: 152px;
        text-align: center;
        /*margin: 0 10px;*/
    }

</style>
